import { call, put } from "redux-saga/effects";
import { dataEtfsLoaded, dataLoadingComplete } from "../actions";
import { ScreenerEtfService } from "../../services/etf-service";
import { ScreenerEtfBackendModel } from "../../services/model";
import { calculateFilterSettings } from "./calculateFilterSettings";
import { paramsToQueryStringDeserialize } from "./paramsToQueryStringDeserialize";
import { filterTable } from "./filterTable";
import { prerenderMarkLoaded } from "shared/mechanics/prerender";
import { getPremiumEtfTickers } from "helpers";

const premiumEtfTickers = getPremiumEtfTickers();
function isPremium(ticker: string) { return premiumEtfTickers.indexOf(ticker) !== -1; }

export function* loadingSaga() {
	const etfs: ScreenerEtfBackendModel[] = yield call(ScreenerEtfService.etfs);
	etfs.sort((a, b) => {
		const premiumCompare = premiumEtfTickers.indexOf(b.ticker) - premiumEtfTickers.indexOf(a.ticker);
		if (premiumCompare !== 0)
			return premiumCompare;

		return (a.tradeStatus?.sortOrder || 0) - (b.tradeStatus?.sortOrder ?? 0);
	})

	yield put(dataEtfsLoaded(etfs));

	yield call(calculateFilterSettings, false);
	yield call(paramsToQueryStringDeserialize);
	yield call(filterTable);

	yield put(dataLoadingComplete());

	prerenderMarkLoaded();
}